import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModalActions from 'app/actions/ModalActions';
import LikesActions from 'app/actions/LikesActions';
import UgcLikesButton from './UgcLikesButton';

export class UgcLikesButtonContainer extends React.PureComponent {
  render() {
    return <UgcLikesButton {...this.props} />;
  }
}

UgcLikesButtonContainer.propTypes = {
  // ownProps
  buttonText: PropTypes.string.isRequired,
  buttonType: PropTypes.oneOf(['primary', 'secondary']),
  contentId: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,

  // Redux props
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  likesActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch),
  likesActions: bindActionCreators(LikesActions, dispatch)
});

export default connect(null, mapDispatchToProps)(UgcLikesButtonContainer);
